// eslint-disable-next-line import/named
import { DatePickerInput } from '@mantine/dates';
import { clsx } from 'clsx';
import { IDatePickerInput } from './types';
import { calendarClassNames, calendarCardClassNames } from '../JxtDatePicker/classNames';
import JxtMantineProvider from '../JxtMantineProvider';

const JxtDatePickerInput = (props: IDatePickerInput) => {
  const baseInputClasses =
    'min-w-min text-center rounded-lg border text-body-s text-neutral-120 empty:text-neutral-80 bg-white disabled:border-neutral-10 disabled:text-neutral-60 focus:outline-hidden focus:ring-4 py-2';
  const errorClasses = props.invalid
    ? 'border-red-100 focus:ring-red-50 hover:border-red-30 focus:border-red-100'
    : 'hover:border-neutral-30 border-neutral-20 focus:ring-primary-30 focus:border-primary-100';

  const refinedProps = Object.fromEntries(
    Object.entries(props).filter(([key]) => !['className', 'invalid'].includes(key))
  );

  return (
    <JxtMantineProvider>
      <div className={clsx('flex flex-col gap-2', props.className)}>
        <DatePickerInput
          {...refinedProps}
          popoverProps={{
            classNames: {
              dropdown: 'p-0 border-none bg-transparent',
            },
          }}
          classNames={{
            ...calendarClassNames,
            ...calendarCardClassNames,
            input: clsx(baseInputClasses, errorClasses),
          }}
        />
      </div>
    </JxtMantineProvider>
  );
};

export default JxtDatePickerInput;
